import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import setting from './projectSettings.js'
axios.defaults.timeout = 30000
axios.defaults.baseURL = 'http://160.255.0.63:8088/elecstatistic/rest/'
axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
//http request 拦截器
axios.interceptors.request.use(
    config => {
      // 在发送请求之前做些什么
      // 发送请求之前判断是否存在token，除了登录页，其他页面请求头headers都添加token
      console.log('加载中...')
      setting.tips('加载中...')
      // Indicator.open({
      //   text: '加载中...',
      //   spinnerType: 'fading-circle'
      // })
      return config
    },
    err => {
      Indicator.close()
      Toast({
        message: '加载超时',
        position: 'middle',
        duration: 3000
      })
      return Promise.reject(err)
    }
)
//http response 拦截器
axios.interceptors.response.use(
    response => {
      Indicator.close()
      return response
    },
    error => {
      console.log(error)
      Indicator.close()
      return Promise.reject(error)
    }
)
let startAjax = function (options) {
  return new Promise(function (resolve,reject) {
    if(options && options.url && options.code){
        let ajaxSettings = {
          url : options.url,
          method : 'POST',
          headers : {

          },
          data :options.isRep?(options.data):(qs.stringify(options.data) || ''),
        }
        return axios(ajaxSettings).then(function (data) {
          let orgindata = data;
          let res = data.data;
          if(res.login === false){
            redirectToLogin();
          }else{
            if(res.success === false){
              setting.tip(res.errInf.metailBusInf);
              resolve(orgindata);
            }else{
              resolve(res);
            }
          }
        }).catch(function (data) {
          reject(data);
        })
    }else{
      reject('参数错误！');
      setting.tips('参数错误！');
    }
  })
}
export default {
  postAjax(options){
    return startAjax(options);
  },
}


// WEBPACK FOOTER //
// ./src/util/util.js